import { Form, Select, Space, Typography } from "antd";
import { Notice } from "../common/Notice";
import type { ValidationLevel } from "../../types/validation.types";

interface SurveyMinLevelFieldProps {
  value?: ValidationLevel;
  effectiveLevel?: ValidationLevel;
  platformFloorApplied?: boolean;
  disabled?: boolean;
  onChange?: (value: ValidationLevel) => void;
}

const levelLabel: Record<ValidationLevel, string> = {
  LEVEL_1: "Nível 1 (Básico)",
  LEVEL_2: "Nível 2 (Telefone)",
  LEVEL_3: "Nível 3 (Documento - Em breve)",
};

export function SurveyMinLevelField({
  value = "LEVEL_1",
  effectiveLevel = "LEVEL_1",
  platformFloorApplied = false,
  disabled,
  onChange,
}: SurveyMinLevelFieldProps) {
  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Form.Item label="Nível mínimo de validação" name="minimumValidationLevel">
        <Select value={value} onChange={onChange} disabled={disabled}>
          <Select.Option value="LEVEL_1">{levelLabel.LEVEL_1}</Select.Option>
          <Select.Option value="LEVEL_2">{levelLabel.LEVEL_2}</Select.Option>
          <Select.Option value="LEVEL_3" disabled>{levelLabel.LEVEL_3}</Select.Option>
        </Select>
      </Form.Item>

      <Typography.Text type="secondary">
        Nível efetivo aplicado: {levelLabel[effectiveLevel]}
      </Typography.Text>

      {platformFloorApplied && (
        <Notice
          type="info"
          showIcon
          message="A plataforma aplicou um floor global acima do nível selecionado."
        />
      )}

      <Typography.Text type="secondary">Nível 3 (documentação): Em breve.</Typography.Text>
    </Space>
  );
}

export default SurveyMinLevelField;
